exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.view-box[data-v-7201167a] {\n  width: 100%;\n  height: calc(100vh - 2.4rem);\n  border: none;\n}\n", ""]);

// exports
